import { stringSearch } from '@luminovo/design-system';
import { createFileRoute, redirect } from '@tanstack/react-router';

import type { PageStaticData } from '@/shared/routing';

// A scenario has no page of its own. Only redirects: the line items check their own access.
export const Route = createFileRoute('/_authenticated/projects/$projectId/sourcing/scenarios/$sourcingScenarioId/')({
    staticData: { access: 'authenticated', chrome: 'project' } satisfies PageStaticData,
    validateSearch: stringSearch({ assemblyId: 'optional' }),
    beforeLoad: ({ params }) => {
        throw redirect({
            to: '/projects/$projectId/sourcing/scenarios/$sourcingScenarioId/line-items',
            params: { projectId: params.projectId, sourcingScenarioId: params.sourcingScenarioId },
            search: true,
            replace: true,
        });
    },
});
